import * as React from 'react'
import { useState } from 'react'

const Overview = ({ abstractTncLink, logo, onNext, submissionDeadline }) => {
  const [showFullGuideline, setShowFullGuideline] = useState(false)

  const handleCreateButton = () => {
    onNext()
  }

  return (
    <>
      {/* Conference Card */}
      <div className="flex items-center justify-between w-full h-32 px-6 py-4 bg-white border border-blue-200 rounded-lg">
        <div className="flex items-center h-full space-x-5">
          <img
            src={logo}
            alt="Conference Logo"
            className="object-contain w-20 h-20"
          />

          <div className="flex flex-col justify-center">
            <p className="text-sm font-normal leading-5 text-gray-600">
              Conference
            </p>
            <p className="text-2xl font-bold leading-8 text-gray-900">
              MACRO 2026
            </p>
          </div>
        </div>
      </div>
      <div className="relative w-full bg-white">
        <div className="flex flex-col items-center w-full space-y-10">
          {/* Submit Abstract Section */}
          <div className="flex flex-col items-start w-full space-y-10 ">
            <div className="flex items-start justify-between w-full p-6 space-x-5 bg-white border-2 border-blue-200 rounded-lg">
              <div className="flex flex-col space-y-5 grow">
                <div className="flex flex-col w-full space-y-2">
                  <p className="text-lg font-bold leading-8 text-gray-900">
                    Submit Abstract
                  </p>
                  <div className="text-sm font-normal leading-5 text-gray-600">
                    <p className="mb-0">
                      Each presenter may submit ONE abstract only.
                    </p>
                    <p>
                      You can only submit your final presentation after
                      registering for the conference.
                    </p>
                  </div>
                </div>
                <p className="text-sm font-bold leading-5 text-blue-900">
                  Submission Deadline: {submissionDeadline ? submissionDeadline : "15th April 2026"}
                </p>
                <p className="text-xs font-normal leading-5 text-gray-600">
                  Click here for
                  <span className="text-blue-900 underline">
                    {' '}
                    <a
                      href={abstractTncLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Abstract Submission Terms and Conditions
                    </a>
                  </span>
                </p>
              </div>

              <button
                onClick={handleCreateButton}
                className="flex items-center px-5 py-2 transition-colors bg-blue-900 rounded cursor-pointer hover:bg-blue-800"
              >
                <div className="flex items-center space-x-2">
                  <div className="w-6 h-6">
                    <svg
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-full h-full"
                    >
                      <path
                        d="M12.5 5v15M5 12.5h15"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <p className="text-sm font-normal leading-6 text-white whitespace-nowrap">
                    Create New Abstract
                  </p>
                </div>
              </button>
            </div>

            {/* Submission Guideline */}
            <div className="flex flex-col items-start w-full p-6 space-y-5 bg-white border-2 border-blue-200 rounded-lg">
              <div className="flex flex-col w-full space-y-2">
                <h5 className="mb-2 text-lg font-bold leading-8 text-gray-900">
                  Submission Guideline
                </h5>
                <div
                  className={`text-sm font-normal leading-5 text-gray-600 text-justify ${
                    showFullGuideline ? '' : 'h-24 overflow-hidden'
                  }`}
                >
                  <p className="mb-0">
                    <h6>SUBMISSION GUIDELINES / TERMS & CONDITIONS</h6>

                    <ol>
                      <li>
                        Submitter will be the default{' '}
                        <strong>presenting author</strong>.
                      </li>
                      <li>
                        Each presenter may submit <strong>ONE</strong> abstract
                        only.
                      </li>
                      <li>
                        Submissions should be sent electronically via the
                        congress website only. Abstracts submitted by fax, email
                        or paper copy will NOT be considered.
                      </li>
                      <li>
                        Abstracts must be submitted in <strong>English</strong>{' '}
                        using the Online Abstract Submission Form.{' '}
                      </li>
                      <li>
                        Abstract texts should have the following structure:
                        Introduction, Objectives, Methods, Results and
                        Conclusions, with a maximum of 300 words.
                      </li>
                      <li>The abstract allows graphics or references.</li>
                      <li>
                        All the abstract content must fit into{' '}
                        <strong>ONE</strong> page (including of graphic and
                        references, if any.)
                      </li>
                      <li>
                        Submissions should be thoroughly checked for spelling
                        and grammar before submission as they will be reproduced
                        as submitted by the author. Submitters are advised to
                        seek assistance to proofread the abstract if English is
                        not their first language.
                      </li>
                      <li>
                        Once the abstract submission has been successful, a
                        confirmation email will be sent to you. Please ensure
                        your email address is correct.
                      </li>
                      <li>
                        Changes will not be entertained once the abstract has
                        been submitted.
                      </li>
                    </ol>

                    <h6 className="mt-3">CONSENT, PERMISSION & COPYRIGHT</h6>
                    <ul>
                      <li>Submitters must conform to the following:</li>
                      <li>
                        To accept responsibility for the accuracy of the
                        submitted abstract and understand that amendment is not
                        allowed once it is submitted, and information provided
                        will be published exactly as submitted.
                      </li>
                      <li>
                        All co-authors are aware of and give consent to the
                        content of the abstract and data presented before it is
                        submitted. The submitter accepts responsibility as the
                        contact person for all correspondence about the abstract
                        and to share information with all authors about its
                        status.
                      </li>
                      <li>
                        Submission of abstracts implies the author’s agreement
                        to publish the abstract in all congress publications
                        including the website, i.e., submitters are responsible
                        to secure any copyright/permissions clearance required
                        relating to any previous presentations, equipment, or
                        other material for inclusion in the MACRO 2026
                        publications.
                      </li>
                      <li>
                        Submitters are responsible to obtain permission from any
                        relevant regulatory authority and obtain consent where
                        appropriate.
                      </li>
                      <li>
                        Submitters are responsible to ensure the work is
                        original and that it does not infringe upon any
                        copyright, proprietary or personal right of party.
                      </li>
                      <li>
                        Submitters are responsible to identify and sort out any
                        potential conflicts of interest e.g., financial interest
                        in products or processes described in the presentation
                        materials, stock ownership, and membership on an
                        advisory board or board of directors or other
                        substantive relationships.
                      </li>
                      <li>
                        Submission of the online Registration and Abstract
                        Submission form indicates the submitter has agreed to
                        all the terms & conditions with regards to the congress
                        registrations and abstract submissions as listed on the
                        congress website.
                      </li>
                      <li>
                        It is a pre-requisite of the acceptance of the abstract
                        that the submitter must register to attend the congress
                        in person (physical attendance). Abstracts submitted
                        before payment of registration are eligible for an offer
                        of acceptance. However, final acceptance requires
                        registration with full payment by{' '}
                        <strong>31 March 2026</strong>.
                      </li>
                    </ul>
                  </p>
                </div>
                <button
                  onClick={() => setShowFullGuideline(!showFullGuideline)}
                  className="flex items-center justify-center w-full p-0 space-x-2 bg-transparent border-0 cursor-pointer"
                >
                  <p className="text-base font-normal leading-6 text-center text-gray-500">
                    {showFullGuideline ? 'Show Less' : 'Show More'}
                  </p>
                  <div
                    className={`w-5 h-2 transition-transform ${
                      showFullGuideline ? 'transform rotate-180' : ''
                    }`}
                  >
                    <svg
                      viewBox="0 0 18 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-full h-full"
                    >
                      <path
                        d="M1 1l8 6 8-6"
                        stroke="#6B7280"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Overview
